import React from 'react';
import { useAppSelector } from 'src/services/redux/app/store';
import { ExploreMain, ActivityDrawer, Main, InviteUsers, UpgradePlan } from '../partials';
import { MasterInit } from './MasterInit';
import { Content } from './components/Content';
import { Footer } from './components/Footer';
import { ScrollTop } from './components/ScrollTop';
import { AsideDefault } from './components/aside/AsideDefault';
import { HeaderWrapper } from './components/header/HeaderWrapper';
import { Toolbar } from './components/toolbar/Toolbar';
import { PageDataProvider } from './core';
import ImpersonateBanner from 'src/app/modules/auth/components/ImpersonateBanner';
import ReleaseNoteModal from 'src/app/modules/release-notes/ReleaseNoteModal';
import AnnouncementModal from 'src/app/modules/announcements/AnnouncementModal';
import FloatingTaskTracker from 'src/app/components/FloatingTaskTracker';
import GlobalAssistant from 'src/app/components/global-assistant/GlobalAssistant';
import NotificationDock from 'src/app/components/notification-dock/NotificationDock';
import FeatureTourProvider from 'src/app/components/feature-tour/FeatureTourProvider';
import ElementPicker from 'src/app/components/feature-tour/ElementPicker';

const MasterLayout: React.FC = ({ children }) => {
  const { user } = useAppSelector((state) => state.auth);

  if (user?.company?.is_maintance) return null;

  return (
    <PageDataProvider>
      {/* Özellik turları (walkthrough): turlar burada kayıt olur, spot ışıklı rehber burada çizilir */}
      <FeatureTourProvider>
        <ImpersonateBanner />
        <div className="page d-flex flex-row flex-column-fluid">
          <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
            <HeaderWrapper />

            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
              <Toolbar />
              <div className="post d-flex flex-column-fluid" id="kt_post">
                <Content>{children}</Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <ExploreMain /> */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        <ReleaseNoteModal />
        <AnnouncementModal />
        {/* end:: Modals */}

        <FloatingTaskTracker />
        {/* SupportFeedbackButton artık Footer'ın sol ikon grubunda (bottombar) */}
        <GlobalAssistant />
        {/* Zil bildirimleri: kenara yapışan sürüklenebilir düğme + alttan açılan panel */}
        <NotificationDock />
        {/* Rehber editörünün 'Sayfada seç' aracı (?tourPick=1) */}
        <ElementPicker />
        <MasterInit />
        <ScrollTop />
      </FeatureTourProvider>
    </PageDataProvider>
  );
};

export { MasterLayout };
